import SalesOffice from './SalesOffice'
import Employee from './Employee'
import Feature from './Feature'
import AppSetting from './AppSetting'

export class UserInfo {
    public Employee: Employee;
    public SalesOffice: SalesOffice;
    public Features: Feature[];
    AppSettings: AppSetting[];
}

export default UserInfo;